export const getRelativeCoordinates = (event, element) => {
    const position = {
      x: event.pageX,
      y: event.pageY
    };
  
    const offset = {
      left: element.offsetLeft,
      top: element.offsetTop
    };
  
    let reference = element.offsetParent;
  
    while (reference != null) {
      offset.left += reference.offsetLeft;
      offset.top += reference.offsetTop;
      reference = reference.offsetParent;
    }
  
    return {
      x: position.x - offset.left,
      y: position.y - offset.top
    };
  }


// WEBPACK FOOTER //
// ./src/util/coordinates.js